import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_brand = `${hostApi}/api/app/brands`

function getBrandList(params) {
    return Vue.prototype.$http.get(api_brand, { params });
}

function getBrand(id) {
    return Vue.prototype.$http.get(`${api_brand}/${id}`);
}

export {
    getBrandList,
    getBrand,
};
